import { createSelector } from 'reselect';
import type { RootState } from '../root-reducer';
import { hostEffectiveEntitlementsSelector } from '../campaignHostSubscription/selectors';

const root = (state: RootState) => state.brandOps;

export const brandOpsSelector = root;

export const brandOpsHomeStatsSelector = createSelector(root, s => s.homeStats);
export const brandOpsFetchingHomeStatsSelector = createSelector(root, s => s.fetchingHomeStats);

export const brandOpsAccessSelector = createSelector(root, s => s.access);
export const brandOpsFetchingAccessSelector = createSelector(root, s => s.fetchingAccess);
export const brandOpsTeamSelector = createSelector(root, s => s.team);
export const brandOpsFetchingTeamSelector = createSelector(root, s => s.fetchingTeam);
export const brandOpsInvitingSelector = createSelector(root, s => s.inviting);
export const brandOpsContractsSelector = createSelector(root, s => s.contracts);
export const brandOpsFetchingContractsSelector = createSelector(root, s => s.fetchingContracts);
export const brandOpsActiveContractSelector = createSelector(root, s => s.activeContract);
export const brandOpsFetchingContractSelector = createSelector(root, s => s.fetchingContract);
export const brandOpsMutatingContractSelector = createSelector(root, s => s.mutatingContract);
export const brandOpsCalendarSelector = createSelector(root, s => s.calendar);
export const brandOpsFetchingCalendarSelector = createSelector(root, s => s.fetchingCalendar);
export const brandOpsSettingsSelector = createSelector(root, s => s.settings);
export const brandOpsKnowledgeSelector = createSelector(root, s => s.knowledge);
export const brandOpsFetchingKnowledgeSelector = createSelector(root, s => s.fetchingKnowledge);
export const brandOpsMutatingKnowledgeSelector = createSelector(root, s => s.mutatingKnowledge);
export const brandOpsAiResultSelector = createSelector(root, s => s.aiResult);
export const brandOpsAiBusySelector = createSelector(root, s => s.aiBusy);
export const brandOpsInboxSelector = createSelector(root, s => s.inbox);
export const brandOpsFetchingInboxSelector = createSelector(root, s => s.fetchingInbox);
export const brandOpsInboxStatusSelector = createSelector(root, s => s.inboxStatus);
export const brandOpsConversationsSelector = createSelector(root, s => s.conversations);
export const brandOpsFetchingConversationsSelector = createSelector(root, s => s.fetchingConversations);
export const brandOpsConversationMessagesSelector = createSelector(root, s => s.conversationMessages);
export const brandOpsFetchingMessagesSelector = createSelector(root, s => s.fetchingMessages);
export const brandOpsSendingMessageSelector = createSelector(root, s => s.sendingMessage);
export const brandOpsUgcAssetsSelector = createSelector(root, s => s.ugcAssets);
export const brandOpsFetchingUgcAssetsSelector = createSelector(root, s => s.fetchingUgcAssets);
export const brandOpsMutatingEscrowSelector = createSelector(root, s => s.mutatingEscrow);
export const brandOpsDownloadingPdfSelector = createSelector(root, s => s.downloadingPdf);
export const brandOpsApiUnavailableSelector = createSelector(root, s => s.apiUnavailable);
export const brandOpsErrorSelector = createSelector(root, s => s.error);
export const brandOpsFetchingMyMembershipsSelector = createSelector(root, s => s.fetchingMyMemberships);
export const brandOpsMyMembershipsFetchedSelector = createSelector(root, s => s.myMembershipsFetched);
export const brandOpsMyContractSelector = createSelector(root, s => s.myContract);
export const brandOpsFetchingMyContractSelector = createSelector(root, s => s.fetchingMyContract);
export const brandOpsAutomationsSelector = createSelector(root, s => s.automations);
export const brandOpsFetchingAutomationsSelector = createSelector(root, s => s.fetchingAutomations);
export const brandOpsMutatingAutomationSelector = createSelector(root, s => s.mutatingAutomation);
export const brandOpsContractClarificationsSelector = createSelector(root, s => s.clarifications);
export const brandOpsFetchingClarificationsSelector = createSelector(root, s => s.fetchingClarifications);
export const brandOpsReplyingToClarificationSelector = createSelector(root, s => s.replyingToClarification);
export const brandOpsPendingClarificationCountSelector = createSelector(root, s => s.pendingClarificationCount);
export const brandOpsPendingContractSignedCountSelector = createSelector(root, s => s.pendingContractSignedCount);
export const brandOpsPendingContractDeclinedCountSelector = createSelector(root, s => s.pendingContractDeclinedCount);
export const brandOpsPendingNewDmCountSelector = createSelector(root, s => s.pendingNewDmCount);
export const brandOpsLastNewDmSelector = createSelector(root, s => s.lastNewDm);

/** Entitlement + access gate for Brand Manage content */
export const brandOpsHasContentManagerSelector = createSelector(
    hostEffectiveEntitlementsSelector,
    brandOpsAccessSelector,
    (entitlements, access) => {
        if (access?.has_content_manager === true || access?.can_access === true) return true;
        return entitlements.content_manager === true;
    },
);

export const brandOpsCanManageWalletSelector = createSelector(brandOpsAccessSelector, access => {
    if (!access) return true;
    if (typeof access.can_manage_wallet === 'boolean') return access.can_manage_wallet;
    if (access.is_brand_admin === false) return false;
    return true;
});

export const brandOpsIsBrandAdminSelector = createSelector(brandOpsAccessSelector, access => {
    if (!access) return true;
    if (typeof access.is_brand_admin === 'boolean') return access.is_brand_admin;
    return access.role === 'brand_admin' || access.role == null;
});
